import { inject, Injectable } from "@angular/core";
import { StockApi } from "../Api/StockApi";
import { StockState } from "./StockState";
import { CreateStockAdjustmentRequest } from "../Dto/CreateStockAdjustmentRequest";
import { Stock } from "../Dto/StockModel";
import { StockSummaryRequest } from "../Dto/StockSummaryRequest";
import { createBackendError, getBackendErrorMessage } from "../../../Common/Utility/UtilityError";

@Injectable({ providedIn: "root" })
export class StockEffects {
  private readonly stockApi = inject(StockApi);
  private readonly stockState = inject(StockState);

  async searchStockSummary(params: StockSummaryRequest = {}): Promise<void> {
    const mergedParams: StockSummaryRequest = { page: 1, limit: 12, ...params };

    this.stockState.setLoading(true);
    this.stockState.setError(null);

    try {
      const response = await this.stockApi.searchStockSummary(mergedParams);
      this.stockState.setSummary(response.data, response.totals, response.pagination);
      this.stockState.setSearchParams(mergedParams);
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.stockState.setError(errorMessage);
    } finally {
      this.stockState.setLoading(false);
    }
  }

  async createAdjustment(payload: CreateStockAdjustmentRequest): Promise<Stock> {
    try {
      return await this.stockApi.createAdjustment(payload);
    } catch (exception: unknown) {
      this.stockState.setError(getBackendErrorMessage(exception));
      throw createBackendError(exception);
    }
  }
}
